import _uniq from 'lodash/uniq';
import type { GeospatialItem, QuantitativeItem } from '$lib/sanity/schemas';

export const convertToClass = (str: string) => {
  return str.replaceAll(' ', '-').toLowerCase();
};

/**
 * Sanity documents can start with numbers and create an invalid html id.
 * This function add a prefix to the id to prevent that.
 */
export const formatDocumentId = (id: string) => {
  return `chart-${id}`;
};

export const formatGraphValue = (value: number, prefix: string, suffix: string) => {
  const number = Number.isInteger(value) ? value : value.toFixed(1);

  return `${prefix}${number}${suffix}`;
};

type Categories = {
  primary: string[];
  secondary: string[];
  tertiary: string[];
};

export const categorizeChartItems = (items: (GeospatialItem | QuantitativeItem)[]): Categories => {
  let primary: string[] = [];
  let secondary: string[] = [];
  let tertiary: string[] = [];

  items.forEach((item) => {
    if (item.primaryCategory) primary.push(item.primaryCategory);
    if (item.secondaryCategory) secondary.push(item.secondaryCategory);
    if (item.tertiaryCategory) tertiary.push(item.tertiaryCategory);
  });

  primary = _uniq(primary);
  secondary = _uniq(secondary);
  tertiary = _uniq(tertiary);

  return { primary, secondary, tertiary };
};
